import { fetchWrapper } from "@coxauto-ui/core-http";
import { getBaseUrl, getHeader } from "../config";
import {
  GetTemplateContentRequest,
  GetTemplateContentResponse
} from "./interfaces/get-template-content";
import { Environment } from "@coxauto-ui/cxm/communications/interfaces";

export async function getTemplateContent(
  data: GetTemplateContentRequest,
  env: Environment
): Promise<GetTemplateContentResponse> {
  const url = `${getBaseUrl(env)}cxm/templatecontent`;
  const header = await getHeader();
  const queryParams = new URLSearchParams({
    dealerId: data.dealerId.toString(),
    conversationType: data.conversationType,
    templateId: data.templateId.toString(),
    consumerId: data.consumerId,
    consumerRecordSystem: data.consumerRecordSystem
  });

  if (data.leadId) {
    queryParams.append("leadId", data.leadId.toString());
  }

  try {
    const response = await fetchWrapper.getAsync<GetTemplateContentResponse>(
      `${url}?${queryParams.toString()}`,
      header
    );

    if (response && response.data && !response.hasError) {
      return response.data;
    } else {
      console.error(
        `Error fetching template content for templateId: ${data.templateId}`,
        response?.error
      );
      return {};
    }
  } catch (error) {
    console.error(
      `Exception fetching template content for templateId: ${data.templateId}`,
      error
    );
    return {}; // Silently fail and return empty object
  }
}
